export default __webpack_public_path__ + "static/media/MarcaBG.78d51112.jpg";